module.exports = __webpack_public_path__ + "static/media/Stevie.be8f223e.jpg";